import cx from "classnames";
import { useState } from "react";

import { Icon, IconName } from "@mitratech/north-star";
import styles from "./Branch.module.scss";

export interface BranchProps {
  branch: string;
  release: string;
}

export const Branch = ({ branch, release }: BranchProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (process.env.NODE_ENV !== "production") {
    return (
      <figure
        tabIndex={0}
        className={cx({
          [styles["branch"]!]: true,
          [styles["branch--expanded"]!]: isExpanded,
        })}
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyDown={(event) => {
          if (["Enter", "Space"].includes(event.code)) setIsExpanded(!isExpanded);
        }}
      >
        <Icon
          className={styles["branch__icon"]!}
          aria-label={isExpanded ? "Hide branch info" : "Show branch info"}
          name={IconName.Developer}
        />

        <figcaption>
          <dt>Branch:</dt>
          <dd>{branch}</dd>

          <dt>Release:</dt>
          <dd>v{release}</dd>
        </figcaption>
      </figure>
    );
  }

  return null;
};
